export default {
    forceFileDownload(data, fileName) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click()
    },

    getActualDateForFileName() {
        const today = new Date().toISOString().split(('T'));

        let date1 = today[0].replace('-', '');
        const date = date1.replace('-', '');
        let time1 = today[1].split('.')[0];
        const time = time1.replace('_', '-');

        return date + '_' + time;
    }
}


// WEBPACK FOOTER //
// ./src/services/filedownloadservice.js